import React, { type JSX } from 'react';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

const CloseIcon = ({ onClick }: { onClick?: () => void }): JSX.Element => (
  <MaskIcon category="Semantics" name="icon-cross" size={20} footprint={14} onClick={onClick} />
);

export default CloseIcon;
